(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[507],{

/***/ 5269:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-service",
      function () {
        return __webpack_require__(4029);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8077);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4115);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8017);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);





var TermOfService = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), termsOfUse = ref[0], setTermsOfUse = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        fetch("https://d1c9i2hjt1qll5.cloudfront.net/htmls/legaldocuments/101d_TermsofUse.html").then(function(data) {
            return data.text();
        }).then(function(html) {
            return setTermsOfUse(html);
        });
    }, []);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_3__["default"], {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "101Digital | Terms of Service"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                as: "h1",
                textStyle: "h1",
                textAlign: [
                    "center",
                    null,
                    null,
                    null,
                    null,
                    "left"
                ],
                mb: [
                    "34px",
                    null,
                    null,
                    null,
                    null,
                    "136px"
                ],
                mt: [
                    "50px",
                    null,
                    null,
                    null,
                    null,
                    "132px"
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                    children: "Terms of Service"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                maxW: "1155px",
                w: "100%",
                mb: [
                    "34px",
                    null,
                    null,
                    null,
                    null,
                    "99px"
                ],
                px: [
                    "28px",
                    null,
                    null,
                    null,
                    null,
                    "16px"
                ],
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                    textStyle: "paragraph",
                    color: "primary",
                    fontSize: [
                        "12px",
                        null,
                        null,
                        null,
                        null,
                        "21px"
                    ],
                    children: termsOfUse && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                        dangerouslySetInnerHTML: {
                            __html: termsOfUse
                        },
                        sx: {
                            p: {
                                fontWeight: 300,
                                fontSize: "21px"
                            },
                            h3: {
                                fontWeight: 700,
                                fontSize: "21px",
                                marginTop: "64px"
                            },
                            '@media (max-width: 575px)': {
                                p: {
                                    fontSize: "12px"
                                },
                                h3: {
                                    fontSize: "12px"
                                }
                            }
                        }
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (TermOfService);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [425,77,774,888,179], function() { return __webpack_exec__(5269); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);